import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectMIRulesSchema = createSelector(
  getProgramsCategory,
  ({ miRulesSchema }) => miRulesSchema,
);
